var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsDateString, IsOptional, IsUUID } from 'class-validator';
/**
 * Patient request for free slots against one of their own treatment plans
 * (PRD #1343, RS-001). The patient sends ONLY the plan and an optional start
 * date — the therapist, treatment, duration and office are all resolved
 * server-side from the plan (continuity), never trusted from the client.
 */
export class FindPatientBookingSlotsDto {
    treatmentPlanId;
    /** Earliest day to search from (defaults to "today" server-side when omitted). */
    searchFrom;
    /**
     * Latest instant to search up to (RS-005). The same-week slot swap sends this
     * to scope the grid to a single calendar week — the invariant guard that a
     * hand swap can never change the weekly count. Omitted for the paging grid,
     * which uses a fixed forward window server-side.
     */
    searchUntil;
    /**
     * Therapist preference (RS-007). Omitted → the plan's continuity therapist
     * (the default a plan-backed pass preselects). A specific id scopes the
     * search to that therapist. `anyTherapist` takes precedence and searches all
     * therapists of the office location with time-deduped chips ("egal").
     */
    therapistId;
    anyTherapist;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], FindPatientBookingSlotsDto.prototype, "treatmentPlanId", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], FindPatientBookingSlotsDto.prototype, "searchFrom", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], FindPatientBookingSlotsDto.prototype, "searchUntil", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], FindPatientBookingSlotsDto.prototype, "therapistId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FindPatientBookingSlotsDto.prototype, "anyTherapist", void 0);
//# sourceMappingURL=find-patient-booking-slots.dto.js.map